import React, {useEffect, useState} from 'react'
import {Text, Image, Flex, Grid, GridItem, Box, Spinner} from '@chakra-ui/react'
import {Link, useParams} from 'react-router-dom'
import {ReactComponent as Unfinished} from "../../../assets/unfinishedIconca.svg";
import {ReactComponent as DownloadIcon} from "../../../assets/cloud-download.svg";
import {ReactComponent as Ready} from "../../../assets/ready.svg";
import styles from '../styles'
import {arrayMove, SortableContainer, SortableElement} from 'react-sortable-hoc';
import httpRequest from "../../../core/services/http-request";
import useCalculator from "../../../core/hooks/useCalculator";
import {useGetReport} from "../../../core/hooks";
import {REPORT_TYPE, SPECIFICATIONS_TYPE} from "../../../constants/orders/orderEnum";
import CustomSpinner from "../../../components/Spinner/CustomSpinner";

const Overview = ({project, user, history, lists, setLists}) => {
    const {post, postPdf} = httpRequest()

    const params = useParams()
    const {calculate, data, isLoading: isLoadingCalculator} = useCalculator(params.reportId)

    const [proposal, setProposal] = useState([])
    const [calcNumbers, setCalcNumbers] = useState({})
    const [financed, setFinanced] = useState(0)
    const {data: reportDataResponse, refetch: refetchReport} = useGetReport(params.reportId)
    const [downloadingPDF, setDownloadingPDF] = useState({type: 'pdf', bool: false, id:null})
    const [ledFinanced, setLedFinanced] = useState([])
    const [projectTotal, setProjectTotal] = useState(0)
    const [totalLoanPdf, setTotalLoanPdf] = useState(0)
    const [totalLoan, setTotalLoan] = useState(0)
    const [yearOneLed, setYearOneLed] = useState(0)

    useEffect(() => {
        if (projectTotal === 0) return
        let total = 0
        let arr = []
        total = (((projectTotal - project.depositAmount) / 100) * project.interestRate) + (projectTotal - project.depositAmount)
        setTotalLoan(total)
        setTotalLoanPdf(total)
        let principalLoanAmount = projectTotal - Number(project.depositAmount)
        let interestDue = principalLoanAmount * Number(project.interestRate)/100
        let totalLoanAmount = principalLoanAmount + interestDue
        let durationYears = Number(project.loanPeriod) / 12
        let annualAmountPaidYear = (totalLoanAmount / durationYears)

        arr.push(project.depositAmount)
        for (let i = 1; i <= 10; i++) {
            if (i <= durationYears){
                arr.push(Math.round((yearOneLed+annualAmountPaidYear)*i))
            } else {
                arr.push(Math.round((yearOneLed*i))+totalLoanAmount)
            }
        }
        setLedFinanced(arr)
        setFinanced(arr)
    }, [projectTotal])

    useEffect(() => {
        if (downloadingPDF.bool) {
            downloadReportPdf();
        }
    }, [downloadingPDF]);
    function getCurrentDateFormatted() {
        const currentDate = new Date()
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0')
        const day = currentDate.getDate().toString().padStart(2, '0')
        const year = currentDate.getFullYear().toString().substr(-2)
        return `${month}.${day}.${year}`
    }
    const downloadReportPdf = () => {
        let resp = {
            reportId: downloadingPDF.id,
            calculate: calcNumbers,
            totalLoan: totalLoanPdf,
            financed: financed,
            pdfType: downloadingPDF.type === 'spec' ? SPECIFICATIONS_TYPE: REPORT_TYPE,
        }
        postPdf('download-report', resp).then((response) => {
            const blob = new Blob([response.data], {type: 'application/pdf'});
            const formattedDate = getCurrentDateFormatted();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${project?.address  + ' - ' +'asd' + ' - ' + formattedDate}.pdf`;
            a.click();
            window.URL.revokeObjectURL(url);
            setDownloadingPDF(false)
        }).catch(() => setDownloadingPDF(false))
    }
    useEffect(() => {
        if (!reportDataResponse) return
        calculate()
        setProposal(reportDataResponse.data.data)
    }, [reportDataResponse])
    useEffect(() => {
        if (!data) return
        let results = data.data.data
        results.installation = proposal?.installation?.total ? proposal?.installation?.total?.toLocaleString('en-US') : 0
        setCalcNumbers(results)
        setProjectTotal(results.projectTotal)
        setYearOneLed(results.yearOneLed)
    }, [data])

    const onSortEnd = (e) => {
        let newLists = arrayMove(lists, e.oldIndex, e.newIndex)
        for (let i = 0; i < newLists.length; i++) {
            newLists[i].sortId = newLists.indexOf(newLists[i])
        }
        setLists(newLists)
        post('sort-reports', newLists)
    }

    const SortableItem = SortableElement(({value}) =>
        <Grid templateColumns="repeat(9, 1fr)" key={value.id} css={styles.trReport} bg="white.100" boxShadow="2px 4px 10px rgba(0, 0, 0, 0.25)" mb={4} minH='57px' alignItems='center' pl={4} _hover={{'background-color': value.status === 'Accepted' ? '#C6FDAF' : '#FFD6C9'}}>
            <GridItem>
                <Image src="/icons/dragBlackIcon.svg" alt="Drag" z-index='1'/>
            </GridItem>
            <GridItem className="no-drag" display={user?.type === 'Reu' ? 'none' : 'flex'}>
                <span style={{'display': 'flex',}}>
                    {value.status === 'Unfinished' ? (<Unfinished/>) : (<Ready/>)}
                    <Text ml={3}>
                            <button style={{zIndex: 999,fontWeight: 400, fontFamily: 'Frank Ruhl Libre'}} onClick={() => history.push(`/projects/proposal/${encodeURIComponent(value.proposalName)}/${project.id}/${value.id}`)}>
                                {value.status}
                            </button>
                        </Text>
                </span>
            </GridItem>
            <GridItem>
                <button className="no-drag" style={{zIndex: 999,fontWeight: 400, fontFamily: 'Frank Ruhl Libre'}} onClick={() => history.push(`/projects/proposal/${encodeURIComponent(value.proposalName)}/${project.id}/${value.id}`)}>
                    {value.proposalName}
                </button>
            </GridItem>
            <GridItem>
                <button className="no-drag" style={{zIndex: 999, fontWeight: 400, fontFamily: 'Frank Ruhl Libre'}} onClick={() => history.push(`/projects/proposal/${encodeURIComponent(value.proposalName)}/${project.id}/${value.id}`)}>
                    {value.systemPrice ? `$${Number(value.systemPrice).toLocaleString('en-US')}` : '-'}
                </button>
            </GridItem>
            <GridItem>
                <button className="no-drag" style={{zIndex: 999,fontWeight: 400, fontFamily: 'Frank Ruhl Libre'}} onClick={() => history.push(`/projects/proposal/${encodeURIComponent(value.proposalName)}/${project.id}/${value.id}`)}>
                    {value.costYear ? `$${Number(value.costYear).toLocaleString('en-US')}` : '-'}
                </button>
            </GridItem>
            <GridItem>
                <button className="no-drag" style={{zIndex: 999,fontWeight: 400, fontFamily: 'Frank Ruhl Libre'}} onClick={() => history.push(`/projects/proposal/${encodeURIComponent(value.proposalName)}/${project.id}/${value.id}`)}>
                    {value.addedCRI ? `${value.addedCRI}` : '-'}
                </button>
            </GridItem>
            <GridItem>
                <button className="no-drag" style={{zIndex: 999,fontWeight: 400, fontFamily: 'Frank Ruhl Libre'}} onClick={() => history.push(`/projects/proposal/${encodeURIComponent(value.proposalName)}/${project.id}/${value.id}`)}>
                    {value.addedLumens ? `${Number(value.addedLumens).toLocaleString('en-US')}` : '-'}
                </button>
            </GridItem>
            <GridItem>
                <button className="no-drag" style={{zIndex: 999,fontWeight: 400, fontFamily: 'Frank Ruhl Libre'}} onClick={() => history.push(`/projects/proposal/${encodeURIComponent(value.proposalName)}/${project.id}/${value.id}`)}>
                    {value.ETAdays ? `${Number(value.ETAdays).toLocaleString('en-US')}` : '-'}
                </button>
            </GridItem>
            <GridItem>
                <button className="no-drag" style={{zIndex: 999,display:"flex"}} onClick={(e) => {
                    e.stopPropagation();
                    setDownloadingPDF({ type: 'print', bool: true, id: value.id });
                }} >
                    {downloadingPDF.bool && downloadingPDF.id === value.id ? (
                        <Spinner
                            thickness="2px"
                            speed="0.45s"
                            color="gray.400"
                            boxSize="12px"
                        />
                    ) : (
                        <DownloadIcon />
                    )}
                </button>
            </GridItem>
        </Grid>)

    const SortableList = SortableContainer(({lists}) => {
        return (
            <Box>
                {lists?.sort(function (a, b) {return a.sortId - b.sortId}).map((value, index) => (
                        <SortableItem key={`item-${value.id}`} index={index} value={value}/>))}
            </Box>
        )
    })

    return (
        <>
            <Box minH={lists?.length > 0 ? '150px' : '230px'}>
                <Grid ml={lists?.length > 0 ? 0 : 10} pl={6} mb={5} fontSize="16px" fontFamily='Titillium Web' templateColumns="repeat(9, 1fr)">
                    <GridItem color='black' as='h2' m={0}>Rank</GridItem>
                    <GridItem color='black' as='h2' m={0} display={user?.type === 'Reu' ? 'none' : 'flex'}>Status</GridItem>
                    <GridItem color='black' as='h2' m={0}>Report</GridItem>
                    <GridItem color='black' as='h2' m={0}>System Price</GridItem>
                    <GridItem color='black' as='h2' m={0}>Cost/Year</GridItem>
                    <GridItem color='black' as='h2' m={0}>Added CRI</GridItem>
                    <GridItem color='black' as='h2' m={0}>Added Lumens</GridItem>
                    <GridItem color='black' as='h2' m={0}>ETA (days)</GridItem>
                    <GridItem color='black' as='h2' m={0}>Download</GridItem>
                </Grid>
                {
                    lists?.length > 0 ? (
                        <SortableList lists={lists} onSortEnd={onSortEnd} lockAxis="y" shouldCancelStart={(e) => e.target.closest('.no-drag')}  />
                    ) : (
                        <Flex border='3px solid #8FCF74' p={14} mx={14} borderRadius='10px'>
                            <Text>Looks like you don’t have any proposals yet... Click the orange Edit Details button to add more property information or <Link to="/contact">
                                <Text as='span' textDecoration='underline'>click here</Text></Link>
                                <Text as='span'> to contact your Energy Consultant.</Text>
                            </Text>
                        </Flex>
                    )
                }
            </Box>
        </>
    )
}

export default Overview